import React, { useContext } from "react"

import MarkdownDataContext from "~contexts/MarkdownDataContext"
import { Link } from "gatsby"
import * as style from "./Next.module.scss"

const Next = ({ children }) => {
  const data = useContext(MarkdownDataContext)

  return (
    <>
      {data.nextPage && (
        <div className={style.next}>
          <Link to={data.nextPage.path}>{children}</Link>
        </div>
      )}
    </>
  )
}

export default Next
